module.exports = __webpack_public_path__ + "static/media/Segment1.e73bd8bb.jpg";